import axios from "axios";

const base = process.env.REACT_APP_BACK_URL || `${window.location.protocol}//${window.location.hostname}:5000`;

type Headers = { headers?: Record<string, string> };

const auth = (token?: string): Headers =>
  token
    ? {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    : {};

export type CategoriaItem = {
  categoria_id: number;
  id?: number;
  nombre: string;
  descripcion?: string | null;
  socios?: number;
  servicios?: number;
  creado_en?: string;
};

export type SocioDeCategoria = {
  socio_id: number | string;
  socio_nombre?: string;
  socio_apellido?: string;
  socio_dni?: string;
  socio_mail?: string;
  socio_categoria_id?: number;
  asignado_en?: string;
};

export type ServicioDeCategoria = {
  servicio_id: number;
  id?: number;
  nombre: string;
  descripcion?: string;
  categoria?: string;
  icono?: string;
  asignados?: number;
};

export const obtenerCategorias = async (token?: string) => {
  const { data } = await axios.get<CategoriaItem[]>(`${base}/categorias`, auth(token));
  return Array.isArray(data) ? data : [];
};

export const obtenerCategoria = async (categoriaId: number, token?: string) => {
  const { data } = await axios.get<CategoriaItem>(`${base}/categorias/${categoriaId}`, auth(token));
  return data;
};

export const crearCategoria = async (
  payload: { nombre: string; descripcion?: string },
  token?: string
) => {
  const { data } = await axios.post(`${base}/categorias`, payload, auth(token));
  return data;
};

export const actualizarCategoria = async (
  categoriaId: number,
  payload: { nombre?: string; descripcion?: string },
  token?: string
) => {
  const { data } = await axios.put(`${base}/categorias/${categoriaId}`, payload, auth(token));
  return data;
};

export const eliminarCategoria = async (categoriaId: number, token?: string) => {
  const { data } = await axios.delete(`${base}/categorias/${categoriaId}`, auth(token));
  return data;
};

export const obtenerSociosDeCategoria = async (categoriaId: number, token?: string) => {
  const { data } = await axios.get<SocioDeCategoria[]>(
    `${base}/categorias/${categoriaId}/socios`,
    auth(token)
  );
  return Array.isArray(data) ? data : [];
};

export const asignarSocioACategoria = async (
  categoriaId: number,
  socioId: number | string,
  token?: string
) => {
  const { data } = await axios.post(
    `${base}/categorias/${categoriaId}/socios`,
    { socioId },
    auth(token)
  );
  return data;
};

export const quitarSocioDeCategoria = async (
  categoriaId: number,
  socioId: number | string,
  token?: string
) => {
  const { data } = await axios.delete(
    `${base}/categorias/${categoriaId}/socios/${socioId}`,
    auth(token)
  );
  return data;
};

export const obtenerServiciosDeCategoria = async (categoriaId: number, token?: string) => {
  const { data } = await axios.get<{
    categoria_id: number;
    nombre_categoria: string;
    total_socios: number;
    servicios: ServicioDeCategoria[];
  }>(`${base}/categorias/${categoriaId}/servicios`, auth(token));
  return data;
};

export const asignarServiciosACategoria = async (
  categoriaId: number,
  payload: { servicios: number[]; sociosIds?: number[] },
  token?: string
) => {
  const { data } = await axios.post(
    `${base}/categorias/${categoriaId}/asignar-servicios`,
    payload,
    auth(token)
  );
  return data;
};

export const obtenerCategoriasDeSocio = async (socioId: number | string, token?: string) => {
  const { data } = await axios.get<CategoriaItem[]>(
    `${base}/categorias/socio/${socioId}`,
    auth(token)
  );
  return Array.isArray(data) ? data : [];
};